import React from "react";
import { Line } from "react-chartjs-2";
import Chart from "chart.js/auto";
import PropTypes from "prop-types";
Chart.register();

const WeeklyMediaPostRecord = ({ dashboardInfo }) => {
  const userData = {
    labels: dashboardInfo?.map((data) => data.day),
    datasets: [
      {
        label: "Media Report",
        data: dashboardInfo?.map((data) => data.total_media),
        backgroundColor: [
          "rgba(255, 99, 132, 0.2)",
          "rgba(54, 162, 235, 0.2)",
          "rgba(255, 206, 86, 0.2)",
          "rgba(75, 192, 192, 0.2)",
          "rgba(153, 102, 255, 0.2)",
          "rgba(255, 159, 64, 0.2)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
        ],
      },
    ],
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        y: {
          beginAtZero: true,
        },
      },
    },
  };

  return (
    <div style={{ width: "100%", height: "100%", position: "relative" }}>
      <Line data={userData} height={100} />
    </div>
  );
};

WeeklyMediaPostRecord.propTypes = {
  dashboardInfo: PropTypes.arrayOf(PropTypes.object),
};
export default WeeklyMediaPostRecord;
